module.exports = __webpack_public_path__ + "static/media/Ape.35a036ca.PNG";